import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/projects/1.png";
import ProjectImg2 from "../../assets/img/projects/2.png";
import ProjectImg3 from "../../assets/img/projects/3.png";

export default function Projects() {
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Awesome Projects</h1>
            <p className="font13">
              Discover the innovative solutions we've created to help businesses thrive in the digital world.
            </p>
          </HeaderInfo>
          
          {/* Updated to show only 3 projects */}
          <ProjectsGrid>
            <ProjectBox
              img={ProjectImg1}
              title="Custom Web Solutions"
              text="Our team creates tailored web solutions to drive success."
              action={() => alert("clicked")}
            />
            <ProjectBox
              img={ProjectImg2}
              title="E-commerce Development"
              text="Building powerful, scalable e-commerce platforms that convert."
              action={() => alert("clicked")}
            />
            <ProjectBox
              img={ProjectImg3}
              title="Mobile App Development"
              text="Innovative mobile apps designed for maximum user engagement."
              action={() => alert("clicked")}
            />
          </ProjectsGrid>

          <div className="row flexCenter" style={{ margin: "50px 0" }}>
            <div style={{ width: "200px" }}>
              <FullButton title="See More Projects" action={() => alert("clicked")} />
            </div>
          </div>
        </div>
      </div>

      <AboutUsSection>
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <VideoWrapper className="flexCenter">
                <video className="radius8" autoPlay loop muted>
                  <source src="./video/videnew.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </VideoWrapper>
            </AddLeft>

            <AddRight>
              <h4 className="font15 semiBold gradient-text">About Us</h4>
              <h2 className="font40 extraBold gradient-text">Innovation at the Core</h2>
              <p className="font12 gradient-text">
                At our company, we are driven by innovation and creativity. Our expert team crafts web and mobile solutions to elevate your business and connect with your audience like never before.
              </p>
              <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                <div style={{ width: "190px" }}>
                  <FullButton title="Get Started" action={() => alert("clicked")} />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton title="Contact Us" action={() => window.location.href = "tel:+1234567890"} border />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </AboutUsSection>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 0 20px;
`;

const HeaderInfo = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
  justify-items: center;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const AboutUsSection = styled.div`
  padding: 100px 0;
  margin: 50px 0;
  background-color: #f7f7f7;
`;

const Advertising = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;

const AddLeft = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
  }
`;

const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 1;
    text-align: center;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 8px;
`;

const ButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

